module.exports = __webpack_public_path__ + "mail.png?406f2ffcfb5478556df1eae81601e0c5";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/mail.png
// module id = 297
// module chunks = 0